import { Common } from './common';
import {
  CareProviderWithAddress,
  CreateValues,
  FindAllOptions,
} from './models/careProvider';

interface BulkUpsertResponse {
  attempts: number;
  errors: string[];
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findSuggestions(
    partialDisplayName: string,
    authenticationCode?: string,
  ): Promise<CareProviderWithAddress[]> {
    const url = this.common.constructPath('/patient-previsit/care-providers', {
      partialDisplayName,
      authenticationCode,
    });
    return this.common.getJSON(url);
  }

  async search(partialDisplayName: string): Promise<CareProviderWithAddress[]> {
    const url = this.common.constructPath('/care-providers/search', {
      partialDisplayName,
    });
    return this.common.getJSON(url);
  }

  async bulkUpsert(careProviders: CreateValues[]): Promise<BulkUpsertResponse> {
    const url = this.common.constructPath('/care-providers');
    return this.common.putJSON(url, {
      careProviders,
    });
  }

  async findAll(options: FindAllOptions): Promise<CareProviderWithAddress[]> {
    const url = this.common.constructPath('/care-providers', options);
    return this.common.getJSON(url);
  }
}
